import React from 'react';
import {Link} from 'react-router-dom';
import FormLists from '../lists/formlists.js'

export default class FormList extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loaded: false,
            errorMessage: "",
            forms: [],
            canEdit: false
        }
    }
    componentDidMount()
    {
        this.loadForms();
    }
    loadForms()
    {
        this.props.api.send({
            controller: "Form",
            action: "GetFormList",
            method: "get",
            success: (result) => {
                this.setState({
                    loaded: true,
                    errorMessage: result.success ? "" : result.message,
                    forms: result.forms,
                    canEdit: result.canEdit
                });
            },
            error: (err) => {
                this.setState({
                    loaded: true,
                    errorMessage: "Unable to retrieve forms."
                })
            }
        })
    }
    render()
    {
        return this.state.loaded ? (
            <div className="lmsdisplayarea">
                <h3>Forms</h3>
                <table className="lmstable" style={{marginTop: "12px"}}>
                    <tbody>
                        <tr>
                            <th>Form Name</th>
                            <th>Description</th>
                            <th width="250">Actions</th>
                        </tr>
                        {this.state.forms.length === 0 ? (
                            <tr>
                                <td colSpan="3">
                                    <i>No forms found.</i>
                                </td>
                            </tr>
                        ) : null}
                        {this.state.forms.map(f =>
                            <tr key={f.formID}>
                                <td>{f.formName}</td>
                                <td>{f.formDescription}</td>
                                <td>
                                    <Link to={"/Forms/" + f.formID} className="lmsbutton">Open</Link>
                                    {this.state.canEdit ? (
                                        <span>
                                            <Link to={"/Forms/edit/" + f.formID} className="lmsbutton">Edit</Link>
                                            <Link to="/" className="lmsbutton" onClick={(e) => e.preventDefault()}>Delete</Link>
                                        </span>
                                    ) : null}
                                </td>
                            </tr>    
                        )}
                    </tbody>
                </table>
                {this.state.canEdit ? (
                    <Link to="/Forms/new" className="lmsbutton">Add Form</Link>
                ) : null}
                <FormLists api={this.props.api}></FormLists>
            </div>
        )  : (
            <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/forms/formlist.js